import { render, staticRenderFns } from "./LocalBank.vue?vue&type=template&id=bec21666&scoped=true&"
import script from "./LocalBank.vue?vue&type=script&lang=js&"
export * from "./LocalBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec21666",
  null
  
)

export default component.exports